export default {
  meta: {
    title: '拓店任务',
  },
};
